module.exports = __webpack_public_path__ + "img/24_5.9b088178.png";